var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4105 18.1139C18.1653 18.4426 17.7896 18.6148 17.3618 18.6148C17.1001 18.6148 16.8369 18.5333 16.611 18.3637L13.2718 15.8593C13.0052 15.6252 12.8174 15.2547 12.8174 14.8582V8.59728C12.8174 7.90858 13.3809 7.34509 14.0696 7.34509C14.7583 7.34509 15.3218 7.90597 15.3218 8.59728V14.2321L18.1606 16.3614C18.7131 16.7782 18.8279 17.5609 18.4105 18.1139Z",
    fill: "#008A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666397 14.0234C0.666397 6.64595 6.6456 0.666748 14.0231 0.666748C21.4475 0.666748 27.3797 6.64595 27.3328 14.0234C27.3328 21.4009 21.4005 27.3801 14.0231 27.3801C6.6456 27.3801 0.666397 21.4009 0.666397 14.0234ZM17.3618 18.6148C17.7896 18.6148 18.1653 18.4426 18.4105 18.1139C18.8279 17.5608 18.7131 16.7782 18.1606 16.3613L15.3218 14.2321V8.59725C15.3218 7.90594 14.7583 7.34506 14.0696 7.34506C13.3809 7.34506 12.8174 7.90854 12.8174 8.59725V14.8582C12.8174 15.2547 13.0052 15.6252 13.2718 15.8593L16.611 18.3637C16.8369 18.5333 17.1001 18.6148 17.3618 18.6148Z",
    fill: "#008A45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3ea58d4ca3411acd1a81e83ffbd03db9.svg";
export { ForwardRef as ReactComponent };